webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUsersData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasAnsweredQuestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return randomSingleQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return answerAjax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return wrongAnswerCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return todayAnswerPrize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return redAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return myPacket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sharePageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return revive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_index_js__ = __webpack_require__(21);



var getUsersData = function getUsersData(data) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/user/userData', data);
};

var hasAnsweredQuestions = function hasAnsweredQuestions(data) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/hasAnsweredQuestions', data);
};

var randomSingleQuestion = function randomSingleQuestion(data) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/randomSingleQuestion', data);
};

var answerAjax = {
  hasAnswered: function hasAnswered(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/hasAnswered', data);
  },
  obtainUserRandomQuestion: function obtainUserRandomQuestion(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/obtainUserRandomQuestion', data);
  },
  obtainTiming: function obtainTiming(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/obtainTiming', data);
  },
  answerSingleQuestion: function answerSingleQuestion(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/answerSingleQuestion', data);
  },
  endTimeSubmit: function endTimeSubmit(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/endTimeSubmit', data);
  }
};

var wrongAnswerCourse = function wrongAnswerCourse(data) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/wrongAnswerCourse', data);
};
var todayAnswerPrize = function todayAnswerPrize(data) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/todayAnswerPrize', data);
};

var redAnswer = {
  bestToday: function bestToday(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/bestToday', data);
  }
};

var myPacket = {
  myRedRecord: function myRedRecord(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/myRedRecord', data);
  },
  myDepositRecord: function myDepositRecord(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/myDepositRecord', data);
  },
  myAnswerAmount: function myAnswerAmount(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/myAnswerAmount', data);
  },
  tixian: function tixian(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/tixian', data);
  }
};

var sharePageData = {
  sharePageData: function sharePageData(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/sharePageData', data);
  },
  unPackRedPack: function unPackRedPack(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/unPackRedPack', data);
  }
};

var revive = {
  hasUserReviceToday: function hasUserReviceToday(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/hasUserReviceToday', data);
  },
  myReviveCard: function myReviveCard(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/myReviveCard', data);
  },
  useReviveCard: function useReviveCard(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/useReviveCard', data);
  },
  useReviveIntegral: function useReviveIntegral(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/answer/useReviveIntegral', data);
  },
  returnIntegral: function returnIntegral(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/answer/returnIntegral', data);
  }

};

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(231),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_index__ = __webpack_require__(26);







var Api = function () {
  function Api() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Api);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Api, [{
    key: "setStorage",
    value: function setStorage(keys, val) {
      var values = val;
      if ((typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(val)) == "object") {
        values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val);
      }
      sessionStorage.setItem(keys, values);
    }
  }, {
    key: "getStorage",
    value: function getStorage(keys) {
      if (!sessionStorage.getItem(keys)) {
        return null;
      }
      try {
        return JSON.parse(sessionStorage.getItem(keys));
      } catch (e) {
        return sessionStorage.getItem(keys);
      }
    }
  }, {
    key: "setVuexStorage",
    value: function setVuexStorage(data) {
      this.setStorage("wxUserInfo", data);
      __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch("wxUserInfoAction", data);
    }
  }, {
    key: "kernel",
    value: function kernel() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return "wx";
      } else {
        if (/android/.test(ua)) {
          return "android";
        } else if (/iphone|ipad|ipod/.test(ua)) {
          return "ios";
        } else {
          return "pc";
        }
      }
    }
  }, {
    key: "ios",
    value: function ios() {
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) return true;
      return false;
    }
  }, {
    key: "isKln",
    value: function isKln() {
      if (/kln_android/.test(navigator.userAgent)) {
        return "kln_android";
      } else if (/kln_ios/.test(navigator.userAgent)) {
        return "kln_ios";
      } else {
        return false;
      }
    }
  }, {
    key: "nativeEvent",
    value: function nativeEvent(names) {
      var appHeaderName = names;
      if (appHeaderName == "医学V视界") {
        appHeaderName = "学术天地";
      } else if (appHeaderName == "专区") {
        appHeaderName = "学术专区";
      }
      if (this.isKln() == "kln_ios") {
        window.webkit.messageHandlers.doSomething.postMessage({
          titleName: appHeaderName
        });
      } else if (this.isKln() == "kln_android") {
        window.doSomething.titleName(appHeaderName);
      }
    }
  }, {
    key: "regPhone",
    value: function regPhone(phone) {
      var phoneReg = /^(((1[3456789][0-9]{1})|(15[0-9]{1}))+\d{8})$/;
      if (phoneReg.test(phone)) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "prefixQuery",
    value: function prefixQuery(argUrl) {
      if (argUrl.split("?").length > 1) {
        return "&";
      } else {
        return "?";
      }
    }
  }, {
    key: "infoWxShareUrl",
    value: function infoWxShareUrl() {
      var shareUrl = location.href;
      if (/\.html\?from\=/.test(shareUrl)) {
        var infoUrl = shareUrl.split("?")[1].split("#")[0];
        var formatReg = new RegExp(infoUrl);
        return shareUrl.replace(formatReg, "").replace(/\?/, "");
      } else {
        return shareUrl;
      }
    }
  }, {
    key: "infoSC",
    value: function infoSC(storageObj) {
      if (!storageObj) {
        sa.identify("", true);
      } else {
        sa.identify(storageObj.id || storageObj.wxOpenId || "", true);
        try {
          sa.setOnceProfile({
            companyName: storageObj.companyName || ""
          });
          sa.setOnceProfile({
            duties: storageObj.duties || ""
          });
          sa.setOnceProfile({
            nickName: storageObj.nickName || ""
          });
          sa.setOnceProfile({
            department: storageObj.department || ""
          });
          sa.setOnceProfile({
            phone: storageObj.phone || ""
          });
          sa.setOnceProfile({
            address: storageObj.address || ""
          });
          sa.setOnceProfile({
            RegisterChannel: storageObj.registerChannel || ""
          });
          sa.setOnceProfile({
            fullName: storageObj.fullName || ""
          });
        } catch (err) {
          console.log("未获得用户缓存信息");
        }
      }
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var pathObj = {
  javaPath: '',
  wxAppId: '',
  domainName: '',
  webSocketPath: 'ws://danmu.yxvzb.com',
  wxAccount: '',
  env: 'yxvzb'
};
var protocol = location.protocol === 'https:' ? 'https' : 'http';

var locationUrl = location.href;
if (/doc\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: protocol + '://doc.jimijiayuan.cn',
    wxAppId: 'wx07d0029693e87412',
    domainName: 'doc.jimijiayuan.cn',
    webSocketPath: 'ws://danmu.yxvzb.com',
    wxAccount: 'linchuang119',
    env: 'doc'
  };
} else if (/www\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: protocol + '://www.jimijiayuan.cn',
    wxAppId: 'wxf1c4eecc87711456',
    domainName: 'www.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.132:8088',
    wxAccount: 'frozenhome'
  };
} else if (/192\.168\.0/.test(locationUrl)) {
  pathObj = {
    javaPath: protocol + '://www.yxvzb.com',
    wxAppId: 'wx89dc34dd18c86446',
    domainName: 'www.yxvzb.com',
    webSocketPath: 'ws://danmu.yxvzb.com',
    wxAccount: 'vzb0066'
  };
} else if (/pc2\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: protocol + '://pc2.jimijiayuan.cn',
    wxAppId: 'wxe37f12b1fa076c1a',
    domainName: 'pc2.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.132:8088',
    wxAccount: 'yiyangkeji_xiaowei'
  };
} else if (/ysh-wxv2\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: protocol + '://ysh-wxv2.jimijiayuan.cn',
    wxAppId: 'wxe37f12b1fa076c1a',
    domainName: 'ysh-wxv2.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.105:8383',
    wxAccount: 'yiyangkeji_xiaowei'
  };
} else if (/sj-wx\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: protocol + '://sj-wx.jimijiayuan.cn',
    wxAppId: 'wx310b45cf0f4ed5b0',
    domainName: 'sj-wx.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.105:8383',
    wxAccount: 'yiyangkeji666666',
    env: 'doc'
  };
} else {
  pathObj = {
    javaPath: protocol + '://wx.yxvzb.com',
    wxAppId: 'wx89dc34dd18c86446',
    domainName: 'wx.yxvzb.com',
    webSocketPath: 'ws://danmu.yxvzb.com',
    wxAccount: 'vzb0066'
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  protocol: protocol,
  env: pathObj.env,
  urlPath: '',
  urlRoutePath: this.urlPath + '/html/newWechat.html#/',
  javaPath: pathObj.javaPath,
  wxAppId: pathObj.wxAppId,
  domainName: pathObj.domainName,
  webSocketPath: pathObj.webSocketPath,
  wxAccount: pathObj.wxAccount,
  wxAuth: function wxAuth(routePage) {
    var r = encodeURIComponent('http://cdn.yxvzb.com/WEB/transfer/index.html?vue_redirect_url=' + routePage);
    return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.wxAppId + '&redirect_uri=http%3a%2f%2f' + this.domainName + '%2frest%2fysh%2fwx%2fwxIndex%2fauthorizeCallback%3fredirectUri%3d' + r + '&response_type=code&scope=snsapi_userinfo&source_type=wx&state=3#wechat_redirect';
  }
});

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(121);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  state: {
    change: false,
    isLogin: false,
    classifyId: {
      categoryName: "",
      id: ""
    },
    headerName: "医学V视界",
    vux: {
      isLoading: false
    },
    showCover: false,
    popup: { show: false, type: 1 },
    wxUserInfo: {},
    courseVideUrl: "",
    flowerCount: 0,
    hasUserRevice: true },
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
}));

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(238),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('transDate', function (input) {
  if (typeof input == 'number') {
    var year = new Date(input).getFullYear(),
        month = new Date(input).getMonth() + 1,
        day = new Date(input).getDate();
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    return year + '-' + month + '-' + day;
  } else {
    return;
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('transMonth', function (input) {
  if (typeof input == 'number') {
    var month = new Date(input).getMonth() + 1,
        day = new Date(input).getDate(),
        month = month < 10 ? '0' + month : month;
    var day = day < 10 ? '0' + day : day;
    var hour = new Date(input).getHours() < 10 ? '0' + new Date(input).getHours() : new Date(input).getHours();
    var min = new Date(input).getMinutes() < 10 ? '0' + new Date(input).getMinutes() : new Date(input).getMinutes();
    return month + '月' + day + '日' + hour + ':' + min;
  } else {
    return;
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('transHours', function (input) {
  if (typeof input == 'number' && input) {
    var Hours = new Date(input).getHours(),
        Minutes = new Date(input).getMinutes();
    Hours = Hours < 10 ? '0' + Hours : Hours;
    Minutes = Minutes < 10 ? '0' + Minutes : Minutes;
    return Hours + ':' + Minutes;
  } else {
    return '';
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('mmdd', function (input) {
  if (typeof input == 'number') {
    var year = new Date(input).getFullYear(),
        month = new Date(input).getMonth() + 1,
        day = new Date(input).getDate();
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;

    if (year != new Date().getFullYear()) {
      return year + '-' + month + '-' + day;
    } else {
      return month + '-' + day;
    }
  } else {
    return '';
  }
});

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(241),
  /* scopeId */
  "data-v-7d0373c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_Home_index_vue__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_Home_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__page_Home_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_Play_index_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_Play_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__page_Play_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_Wrong_index_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_Wrong_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__page_Wrong_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_Finshed_index_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_Finshed_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__page_Finshed_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_CorrectEntry_index_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_CorrectEntry_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__page_CorrectEntry_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__page_MyRedPacket_index_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__page_MyRedPacket_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__page_MyRedPacket_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__page_Share_index_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__page_Share_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__page_Share_index_vue__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes: [{
    path: '/',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__page_Home_index_vue___default.a,
    meta: {
      title: '答题拼图的红包',
      needRegister: false,
      pageName: '答题-首页'
    }
  }, {
    path: '/play',
    name: 'play',
    component: __WEBPACK_IMPORTED_MODULE_3__page_Play_index_vue___default.a,
    meta: {
      title: '答题拼图的红包',
      needRegister: true,
      pageName: '答题-答题页'
    }
  }, {
    path: '/wrong',
    name: 'wrong',
    component: __WEBPACK_IMPORTED_MODULE_4__page_Wrong_index_vue___default.a,
    meta: {
      title: '答题拼图的红包',
      needRegister: true,
      pageName: '答题-答错页'
    }
  }, {
    path: '/finshed',
    name: 'finshed',
    component: __WEBPACK_IMPORTED_MODULE_5__page_Finshed_index_vue___default.a,
    meta: {
      title: '答题拼图的红包',
      needRegister: true,
      pageName: '答题-结束页'
    }
  }, {
    path: '/correct',
    name: 'correct',
    component: __WEBPACK_IMPORTED_MODULE_6__page_CorrectEntry_index_vue___default.a,
    meta: {
      title: '答题拼图的红包',
      needRegister: true,
      pageName: '答题-答对页'
    }
  }, {
    path: '/myredpacket',
    name: 'myredpacket',
    component: __WEBPACK_IMPORTED_MODULE_7__page_MyRedPacket_index_vue___default.a,
    meta: {
      title: '答题拼图的红包',
      needRegister: false,
      pageName: '答题-我的红包页'
    }
  }, {
    path: '/share/:redPackId',
    name: 'share',
    component: __WEBPACK_IMPORTED_MODULE_8__page_Share_index_vue___default.a,
    meta: {
      title: '答题拼图的红包',
      needRegister: false,
      pageName: '答题-分享页'
    }
  }]
}));

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marquee; });


var marquee = {
    data: function data() {
        return {
            currenTranslateY: 0,
            height: '',
            length: 0,
            currentIndex: 0,
            noAnimate: false,
            direction: 'up',
            duration: 200,
            timer: null,
            cloneNode: null,
            interval: 1000
        };
    },

    methods: {
        destroy: function destroy() {
            this.cloneNode = null;
            this.timer && clearInterval(this.timer);
        },
        init: function init() {
            this.destroy();

            console.log(this.cloneNode);
            this.cloneNode = null;
            console.log(this.$refs.box.children.length);
            var firstItem = this.$refs.box.firstElementChild;
            if (!firstItem) {
                return false;
            }
            this.length = this.$refs.box.children.length;

            this.height = this.itemHeight || firstItem.offsetHeight;

            if (this.direction === 'up') {
                this.cloneNode = firstItem.cloneNode(true);
                this.$refs.box.appendChild(this.cloneNode);
            } else {
                this.cloneNode = this.$refs.box.lastElementChild.cloneNode(true);
                this.$refs.box.insertBefore(this.cloneNode, firstItem);
            }
            return true;
        },
        start: function start() {
            var _this = this;

            if (this.direction === 'down') this.go(false);
            this.timer = setInterval(function () {
                if (_this.direction === 'up') {
                    _this.currentIndex += 1;
                    _this.currenTranslateY = -_this.currentIndex * _this.height;
                    console.log(_this.height);
                } else {
                    _this.currentIndex -= 1;
                    _this.currenTranslateY = -(_this.currentIndex + 1) * _this.height;
                }
                if (_this.currentIndex === _this.length) {

                    setTimeout(function () {
                        _this.go(true);
                    }, _this.duration);
                } else if (_this.currentIndex === -1) {
                    setTimeout(function () {
                        _this.go(false);
                    }, _this.duration);
                } else {
                    _this.noAnimate = false;
                }
            }, this.interval + this.duration);
        },
        go: function go(toFirst) {
            this.noAnimate = true;
            if (toFirst) {
                this.currentIndex = 0;
                this.currenTranslateY = 0;
            } else {
                this.currentIndex = this.length - 1;
                this.currenTranslateY = -(this.currentIndex + 1) * this.height;
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.destroy();
    }
};

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_index_js__ = __webpack_require__(20);




var api = new __WEBPACK_IMPORTED_MODULE_2__api_index_js__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (function (tits, descs, imgs, locationLink, targerUrl, callBack) {
  if (!api.isKln()) {
    var turl = locationLink;
    if (targerUrl) {
      turl = targerUrl;
    }
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/rest/ysh/wx/wxIndex/jsApiSignature', { 'url': locationLink }).then(function (res) {
      var resp = res.data.data;
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].wechat.config({
        debug: false,
        appId: resp.appId,
        timestamp: resp.timestamp,
        nonceStr: resp.nonceStr,
        signature: resp.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'previewImage', 'openLocation', 'getLocation']
      });
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].wechat.ready(function () {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].wechat.onMenuShareTimeline({
          title: tits,
          link: turl,
          imgUrl: imgs,
          success: function success() {
            if (callBack) {
              callBack();
            }
          },
          cancel: function cancel() {}
        });

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].wechat.onMenuShareAppMessage({
          title: tits,
          link: turl,
          imgUrl: imgs,
          desc: descs,
          type: 'link',
          dataUrl: '',
          success: function success() {
            if (callBack) {
              callBack();
            }
          },
          cancel: function cancel() {}
        });
      });
    });
  }
});

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

(function (win, tcf) {
	var doc = win.document;
	var docEl = doc.documentElement;
	var metaEl = doc.querySelector('meta[name="viewport"]');
	var dpr = 0;
	var scale = 0;
	var handler = null;

	var flexible = tcf.flexible || (tcf.flexible = {});

	if (metaEl) {
		var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
		if (match) {
			scale = parseFloat(match[1]);
			dpr = parseInt(1 / scale);
		}
	}

	if (!dpr && !scale) {
		var isAndroid = win.navigator.appVersion.match(/android/gi);
		var isIPhone = win.navigator.appVersion.match(/iphone/gi);
		var isLiebao = win.navigator.appVersion.match(/LieBao/gi);
		var isSogou = win.navigator.appVersion.match(/Sogou/gi);
		var clsName = String(isIPhone || isLiebao || isSogou || isAndroid || 'pc').toLowerCase();
		var devicePixelRatio = Math.floor(win.devicePixelRatio) || 1;
		if (isIPhone) {
			if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
				dpr = 3;
			} else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
				dpr = 2;
			} else {
				dpr = 1;
			}
		} else if (isLiebao || isSogou) {
			dpr = 1;
		} else {
			dpr = devicePixelRatio;
		}

		doc.body.classList.add(clsName);
		scale = 1 / dpr;
	}

	if (!metaEl) {
		metaEl = doc.createElement('meta');
		metaEl.setAttribute('name', 'viewport');
		metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ',user-scalable=no');
		if (docEl.firstElementChild) {
			docEl.firstElementChild.appendChild(metaEl);
		} else {
			var wrap = doc.createElement('div');
			wrap.appendChild(metaEl);
			doc.write(wrap.innerHTML);
		}
	}

	docEl.setAttribute('data-dpr', dpr);

	var setFontSize = function setFontSize() {
		var width = docEl.getBoundingClientRect().width;
		if (width / dpr > 540) {
			width = 540 * dpr;
		}
		var rem = width / 10;
		rem = Math.max(rem, 32);
		docEl.style.fontSize = rem + 'px';
		flexible.width = width;
		flexible.rem = win.rem = rem;
	};

	['resize', 'orientationchange'].forEach(function (item) {
		win.addEventListener(item, function (e) {
			clearTimeout(handler);
			handler = setTimeout(setFontSize, 300);
		}, false);
	});

	win.addEventListener('pageshow', function (e) {
		if (e.persisted) {
			clearTimeout(handler);
			handler = setTimeout(setFontSize, 300);
		}
	}, false);

	if (doc.readyState === 'complete') {

		doc.body.style.fontSize = 12 * dpr + 'px';
	} else {
		doc.addEventListener('DOMContentLoaded', function (e) {
			doc.body.style.fontSize = 12 * dpr + 'px';
		}, false);
	}

	setFontSize();

	flexible.dpr = win.dpr = dpr;
	flexible.setFontSize = setFontSize;
	flexible.rem2px = function (d) {
		var val = parseFloat(d) * this.rem;
		if (typeof d === 'string' && d.match(/rem$/)) {
			val += 'px';
		}
		return val;
	};
	flexible.px2rem = function (d) {
		var val = parseFloat(d) / this.rem;
		if (typeof d === 'string' && d.match(/px$/)) {
			val += 'rem';
		}
		return val;
	};
})(window, window['tcf'] || (window['tcf'] = {}));

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_wxShare__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_scClass__ = __webpack_require__(118);








/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$getData = function () {};
    Vue.prototype.$jsonp = __WEBPACK_IMPORTED_MODULE_1_jsonp___default.a;
    Vue.prototype.$config = __WEBPACK_IMPORTED_MODULE_2__config_index__["a" /* default */];
    Vue.prototype.$api = new __WEBPACK_IMPORTED_MODULE_3__api_index__["a" /* default */]();
    Vue.prototype.$wxShareInfo = __WEBPACK_IMPORTED_MODULE_4__public_wxShare__["a" /* default */];
    Vue.prototype.$sa = new __WEBPACK_IMPORTED_MODULE_5__public_scClass__["a" /* default */]();
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_plugins_wechat_index_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_ajax_index_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_toast_index_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_alert_index_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_tools_date_format_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_qs__);











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_ajax_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vux_src_plugins_wechat_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_toast_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_alert_index_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (function () {

  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.interceptors.request.use(function (config) {

    if (config.method == 'get') {} else {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
      config.data = __WEBPACK_IMPORTED_MODULE_7_qs___default.a.stringify(config.data);
    }

    return config;
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });

  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.interceptors.response.use(function (response) {

    return response;
  }, function (error) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$vux.toast.show({
      text: '请您检查网络',
      position: 'top',
      type: 'text',
      width: '5rem'
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_tools_querystring_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_wxShare__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_userGuide_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_ajax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_index_js__ = __webpack_require__(21);











var Api = new __WEBPACK_IMPORTED_MODULE_7__api_index__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (function () {

  var watchStorageHasToGoPage = function watchStorageHasToGoPage() {
    var urls = location.href;
    if (sessionStorage.routerBackPageForAnswer) {
      var goBackFunc = function goBackFunc() {
        var page2 = sessionStorage.routerBackPageForAnswer;
        sessionStorage.removeItem("routerBackPageForAnswer");
        location.href = page2;
      };

      if (/share|home/.test(urls)) {}
    }
    return true;
  };
  watchStorageHasToGoPage();

  __WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].beforeEach(function (to, from, next) {
    if (!/share|correct/.test(to.path)) {
      var shareUrl = __WEBPACK_IMPORTED_MODULE_8__config_index_js__["a" /* default */].javaPath + "/html/answerGold/index210505.html#/home?shareFlag=true";

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__public_wxShare__["a" /* default */])("医术高超的同仁才敢玩：答题拼图", "答对100%中奖！", "http://cdn.yxvzb.com/html/AnswerGold/share1.png", location.href.split("#")[0], shareUrl, "");
    }

    if (to.matched.length === 0) {
      next({ name: "home" });
    }
    __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch("change", true);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__public_userGuide_js__["a" /* userGuide */])(__WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */], to, next);
  });

  __WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].afterEach(function (to, from) {

    var env = __WEBPACK_IMPORTED_MODULE_8__config_index_js__["a" /* default */].env == "doc" ? "资料库-" : "";
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$sa.registerPage({
      platform: "wx",
      operation_tm: new Date().getTime(),

      frompage_name: to.query.isTemp || (to.query.shequn ? 6 : to.query.shareFlag ? "分享" : to.query.visiterId ? "课代表邀请" : from.meta.pageName || ""),
      frompage_url: from.fullPath || "",
      currentpage_name: env + to.meta.pageName,
      currentpage_url: to.fullPath

    });

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$sa.re_pageview();
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch("change", false);
    }, 500);
  });
});

/***/ }),
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(237),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fastclick__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_guide__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugin_index__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_index__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters___ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_reset_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_js_flexible_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_js_flexible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_js_flexible_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters_index_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_animate_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_css_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex_router_sync__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_animate_dist_vue2_animate_min_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_animate_dist_vue2_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue2_animate_dist_vue2_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__public_VuxConfig__ = __webpack_require__(90);


















__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_3_fastclick___default.a.attach(document.body);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15__public_VuxConfig__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__plugin_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__router_guide__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$sa.init();
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__filters___).forEach(function (k) {
	return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter(k, __WEBPACK_IMPORTED_MODULE_8__filters___[k]);
});
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
	router: __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_7__store_index__["a" /* default */],
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
	}
}).$mount('#app-box');

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sa_sdk_javascript__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sa_sdk_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sa_sdk_javascript__);







window.sa = __WEBPACK_IMPORTED_MODULE_5_sa_sdk_javascript___default.a;

var scClass = function () {
  function scClass() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, scClass);

    this.frompage_url = '';
    this.frompage_name = '';
    this.store = __WEBPACK_IMPORTED_MODULE_5_sa_sdk_javascript___default.a.store;
    this.registerData = {
      web_version: window.version || '',
      platform: '',
      operation_tm: '',
      frompage_name: '',
      frompage_url: '',
      currentpage_name: '',
      currentpage_url: '',
      fromcode: '' };
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(scClass, [{
    key: 'getSaSessionData',
    value: function getSaSessionData() {
      var sessionkey = scClass.sessionKey;
      var se = sessionStorage.getItem(sessionkey);
      se && sessionStorage.removeItem(sessionkey);
      se = se ? JSON.parse(se) : null;

      return se;
    }
  }, {
    key: 'setSaSession_href',
    value: function setSaSession_href(route, url) {
      if ((typeof route === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(route)) != 'object') {
        console.error('saSessionData 类型参数类型错误');
      } else {
        if (route.fullPath) {
          sessionStorage.setItem(scClass.sessionKey, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ frompage_url: route.fullPath, frompage_name: route.meta.pageName }));
        } else {
          if (route.frompage_url) {
            sessionStorage.setItem(scClass.sessionKey, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(route));
          } else {
            console.error('setSaSessionData页面参数设置有误!必须有当前route实例或OBJ');
          }
        }
      }
      window.location.href = url ? url : '/html/newWechat.html';
    }
  }, {
    key: 'init',
    value: function init() {
      __WEBPACK_IMPORTED_MODULE_5_sa_sdk_javascript___default.a.init({
        server_url: location.protocol === 'https:' ? 'https://data.yxvzb.com:4006/sa' : 'http://data.yxvzb.com:8006/sa',

        show_log: true,
        is_single_page: true });
    }
  }, {
    key: 'login',
    value: function login(storageObj) {
      if (!storageObj || !storageObj.userDataStatus) {
        __WEBPACK_IMPORTED_MODULE_5_sa_sdk_javascript___default.a.identify('', true);
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sa_sdk_javascript___default.a.login(storageObj.shenceId);
      }
    }
  }, {
    key: 'registerPage',
    value: function registerPage(data) {
      var _this = this;

      var isTemp = [{
        label: '首关',
        value: 1
      }, {
        label: '菜单',
        value: 2
      }, {
        label: '模板消息',
        value: 3
      }, {
        label: '客服消息',
        value: 4
      }, {
        label: '图文消息',
        value: 5
      }, {
        label: '社群空间',
        value: 6
      }];

      var sessionObj = this.getSaSessionData();
      this.registerData = sessionObj && sessionObj.frompage_url ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.registerData, data, sessionObj) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.registerData, data);
      if (this.registerData.frompage_name) {
        isTemp.forEach(function (item) {
          item.value == _this.registerData.frompage_name ? _this.registerData.frompage_name = item.label : '';
        });
      }
    }
  }, {
    key: 'saEvent',
    value: function saEvent(eventName) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fn = arguments[2];

      __WEBPACK_IMPORTED_MODULE_5_sa_sdk_javascript___default.a.track(eventName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, s, this.registerData));
    }
  }, {
    key: 're_pageview',
    value: function re_pageview(data) {
      this.saEvent('re_pageview');
    }
  }, {
    key: 'location_func',
    value: function location_func() {
      var location = '';
      var currentpage_name = this.registerData.currentpage_name;
      if (currentpage_name.includes('专区')) {
        location = '专区内';
      } else if (currentpage_name.includes('面对面')) {
        location = '超级面对面内';
      } else if (currentpage_name.includes('搜索')) {
        location = '搜索';
      } else if (currentpage_name.includes('我的收藏')) {
        location = '我的收藏';
      } else if (currentpage_name.includes('听课记录')) {
        location = '听课记录';
      } else if (currentpage_name.includes('专题')) {
        location = '专题';
      } else if (currentpage_name.includes('商业外链')) {
        location = '商业外链';
      } else {
        location = '首页';
      }
      return location;
    }
  }, {
    key: 're_contentview',
    value: function re_contentview(data) {
      var modelData = {
        type: '',
        name: '',
        release_dt: '',
        contentid: '',
        first_cate: '',
        second_cate: '',
        first_cate_id: '',
        second_cate_id: '',
        author: '',
        page_location: '' };
      modelData.page_location = this.location_func();
      this.saEvent('re_contentview', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, modelData, data));
    }
  }, {
    key: 're_interaction',
    value: function re_interaction(data) {
      var typeList = [{
        label: '直播',
        value: 5
      }, {
        label: '录播',
        value: 6
      }, {
        label: '资讯',
        value: 3
      }, {
        label: '病例',
        value: 2
      }, {
        label: '帖子',
        value: 8
      }];
      var modelData = {
        type: '',
        contentype: '',
        contentid: '',
        contentname: '',
        first_cate: '',
        second_cate: '',
        first_cate_id: '',
        second_cate_id: '',
        author: '',
        page_location: '' };
      modelData.page_location = this.location_func();
      typeList.forEach(function (item) {
        item.value == data.contentype && (data.contentype = item.label);
      });
      this.saEvent('re_interaction', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, modelData, data));
    }
  }, {
    key: 're_zone',
    value: function re_zone(data) {
      var modelData = {
        event_type: '',
        zonename: '',
        zoneid: '' };
      this.saEvent('re_zone', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, modelData, data));
    }
  }, {
    key: 're_activity',
    value: function re_activity(data) {
      var modelData = {
        name: '',
        event_type: '' };
      this.saEvent('re_activity', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, modelData, data));
    }
  }, {
    key: 're_click',
    value: function re_click(data) {
      var modelData = {
        target_name: '',
        target_contentname: '',
        target_contentid: '',
        target_contenturl: '' };
      this.saEvent('re_click', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, modelData, data));
    }
  }, {
    key: 're_userinfo',
    value: function re_userinfo(data) {
      var modelData = {
        userid: '',
        action_type: '',
        register_channel: '',
        meeting_id: '' };
      this.saEvent('re_userinfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, modelData, data));
    }
  }]);

  return scClass;
}();

scClass.sessionKey = 'sainitdata';
/* harmony default export */ __webpack_exports__["a"] = (scClass);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userGuide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_ajax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_tools_querystring_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_index__ = __webpack_require__(26);








var Api = new __WEBPACK_IMPORTED_MODULE_2__api_index__["a" /* default */]();
var userGuide = function userGuide(store, to, next) {

  var userInfoObj = Api.getStorage('wxUserInfo') || null;

  if (userInfoObj && userInfoObj.phone && !store.state.wxUserInfo.phone) {
    Api.setVuexStorage(userInfoObj);
  }

  var toWxAuthThenCallBack = function toWxAuthThenCallBack(name) {

    location.href = __WEBPACK_IMPORTED_MODULE_3__config_index__["a" /* default */].wxAuth(name);
  };

  var userHasAnswered = function userHasAnswered(cb) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.all([__WEBPACK_IMPORTED_MODULE_1__api_ajax__["a" /* revive */].hasUserReviceToday(), __WEBPACK_IMPORTED_MODULE_1__api_ajax__["b" /* answerAjax */].hasAnswered()]).then(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.spread(function (reviceRes, ifaRes) {
      if (reviceRes.data.hasUse == '1') {

        store.commit('SETREVICE', false);
      }
      cb(ifaRes.data.ifAnswered);
    }));
  };

  var getUserInfoFunc = function getUserInfoFunc(store, to, next) {
    if (userInfoObj && userInfoObj.phone && userInfoObj.id) {
      if (to.name == 'play') {
        userHasAnswered(function (ifAnswered) {
          if (ifAnswered == '0') {
            next();
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_ajax__["c" /* hasAnsweredQuestions */])().then(function (resp) {
              var list = resp.data.list;

              var _loop = function _loop(i) {
                if (list[i].isRight == '0' || list[i].isRight == '2') {
                  next({
                    name: 'wrong',
                    query: {
                      rightNum: i + 1,
                      wrongId: list[i].questionId
                    }
                  });
                  return 'break';
                } else if (list.length < 4 && !/0|2/.test(list[i])) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_ajax__["d" /* randomSingleQuestion */])().then(function (randomSingleRes) {
                    next({
                      name: 'wrong',
                      query: {
                        rightNum: i + 1,
                        wrongId: randomSingleRes.data.question.id
                      }
                    });
                  });
                  return 'break';
                } else if (i >= 3) {
                  next({
                    name: 'correct'
                  });
                }
              };

              for (var i = 0; i < list.length; i++) {
                var _ret = _loop(i);

                if (_ret === 'break') break;
              }
            });
          }
        });
      } else {
        next();
      }
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_ajax__["e" /* getUsersData */])().then(function (res) {

        var resp = res.data.data;

        if (resp) {

          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$sa.login(resp);

          if (resp.userDataStatus) {
            Api.setVuexStorage(resp);
            if (to.name == 'play') {
              userHasAnswered(function (ifAnswered) {
                if (ifAnswered == '0') {
                  next();
                } else {
                  next({ name: 'finshed' });
                }
              });
            } else {

              next();
            }
          } else {

            Api.setVuexStorage(resp);

            if (to.meta.needRegister) {

              Api.setStorage('strLogin', {
                url: location.href,
                from: 'answer'
              });
              var registerUrl = '/html/newWechat.html#/register';
              if (/sj-wx|doc\.jimijiayuan/.test(location.href)) {
                registerUrl = '/html/clinical/index.html#/register';
              }
              __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$sa.setSaSession_href(to, registerUrl);
            } else {
              next();
            }
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$vux.toast.show({ text: '即将为您授权', position: 'top', type: 'text', width: '5rem' });
          toWxAuthThenCallBack(location.href);
        }
      }).catch(function (res) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$vux.toast.show({
          text: '请您检查网络,3秒后为您重启页面',

          type: 'cancel',
          width: '5rem',
          onHide: function onHide() {
            location.reload();
          }
        });
      });
    }
  };
  getUserInfoFunc(store, to, next);
};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "change", function() { return change; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "classify", function() { return classify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerName", function() { return headerName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "courseVideUrl", function() { return courseVideUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wxUserInfoAction", function() { return wxUserInfoAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogin", function() { return isLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flowerCount", function() { return flowerCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showCoverAction", function() { return showCoverAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_index_js__ = __webpack_require__(20);


var Api = new __WEBPACK_IMPORTED_MODULE_1__api_index_js__["a" /* default */]();
var change = function change(_ref, item) {
  var commit = _ref.commit;

  commit("CHANGE", item);
};
var classify = function classify(_ref2, item) {
  var commit = _ref2.commit;

  commit("CLASSIFY", item);
};
var headerName = function headerName(_ref3, item) {
  var commit = _ref3.commit;

  if (!item) {
    commit("HEADERNAME", "医学V视界");
  } else {
    commit("HEADERNAME", item);
  }
};

var courseVideUrl = function courseVideUrl(_ref4, item) {
  var commit = _ref4.commit;

  commit("CVU", item);
};
var wxUserInfoAction = function wxUserInfoAction(_ref5, item) {
  var commit = _ref5.commit;

  Api.setStorage("wxUserInfo", item);
  commit("WXUSERINFO", item);
};

var isLogin = function isLogin(_ref6, item) {
  var commit = _ref6.commit;

  Api.setStorage("isLogin", item);
  commit("ISLOGIN", item);
};

var flowerCount = function flowerCount(_ref7, item) {
  var commit = _ref7.commit;

  commit("FLOWERCOUNT", item);
};

var showCoverAction = function showCoverAction(_ref8, item) {
  var commit = _ref8.commit;

  commit("SHOWCOVER", item);
};

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* harmony default export */ __webpack_exports__["a"] = ({
  CHANGE: function CHANGE(state, item) {
    state.change = item;
  },
  CLASSIFY: function CLASSIFY(state, item) {
    state.classifyId = item;
  },
  HEADERNAME: function HEADERNAME(state, item) {
    state.headerName = item;
  },
  CVU: function CVU(state, item) {
    state.courseVideUrl = item;
  },
  WXUSERINFO: function WXUSERINFO(state, item) {
    state.wxUserInfo = item;
    if (item.phone) {
      state.isLogin = true;
    }
  },
  ISLOGIN: function ISLOGIN(state, item) {
    state.isLogin = item;
  },
  FLOWERCOUNT: function FLOWERCOUNT(state, item) {
    state.flowerCount = item;
  },
  SHOWCOVER: function SHOWCOVER(state, item) {
    if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) == 'object') {
      state.popup = item;
    } else {
      state.popup.show = item;
    }
  },
  SETREVICE: function SETREVICE(state, item) {
    state.hasUserRevice = item;
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alert',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(140);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_router__ = __webpack_require__(138);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__ = __webpack_require__(139);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_tools_cookie_index_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_tools_querystring_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_tools_date_format_js__ = __webpack_require__(67);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      goBackList: [],
      animateClass: 'bounceInRight',
      transitionName: 'slide-left'
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    change: function change(state) {
      return state.change;
    },
    wxUserInfo: function wxUserInfo(state) {
      return state.wxUserInfo;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['isLogin'])),
  watch: {
    wxUserInfo: function wxUserInfo(val) {
      if (val.phone) {
        this.isLogin(true);
      }
    },
    '$route': function $route(to, from) {

      if (to.name == 'home') {
        this.goBackList = [];
        this.animateClass = 'bounceInLeft';
        this.transitionName = 'slide-left';
      } else if (this.goBackList.indexOf(to.name) == -1) {

        this.goBackList.push(to.name);

        this.animateClass = 'bounceInRight';
        this.transitionName = 'slide-right';
      } else {

        if (this.goBackList.indexOf(to.name) > this.goBackList.indexOf(from.name)) {
          this.animateClass = 'bounceInRight';
          this.transitionName = 'slide-right';
        } else {
          this.animateClass = 'bounceInLeft';
          this.transitionName = 'slide-left';
        }
      }
    }
  },
  mounted: function mounted() {},
  created: function created() {
    console.log(["                   _ooOoo_", "                  o8888888o", "                  88\" . \"88", "                  (| -_- |)", "                  O\\  =  /O", "               ____/`---'\\____", "             .'  \\\\|     |//  `.", "            /  \\\\|||  :  |||//  \\", "           /  _||||| -:- |||||-  \\", "           |   | \\\\\\  -  /// |   |", "           | \\_|  ''\\---/''  |   |", "           \\  .-\\__  `-`  ___/-. /", "         ___`. .'  /--.--\\  `. . __", "      .\"\" '<  `.___\\_<|>_/___.'  >'\"\".", "     | | :  `- \\`.;`\\ _ /`;.`/ - ` : | |", "     \\  \\ `-.   \\_ __\\ /__ _/   .-` /  /", "======`-.____`-.___\\_____/___.-`____.-'======", "                   `=---='", "^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^", "              佛祖加持       永无BUG"].join('\n'));
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_ajax__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: {
    showLog: {

      default: false
    },
    questionIndex: {
      default: 0
    },
    questionList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reviveNum: {
      default: 0
    },
    integral: {
      default: 0
    }
  },
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_2_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  data: function data() {
    return {
      canClick: true,
      appFlag: false,
      wrongFlag: true
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapMutations */])(['SETREVICE']), {
    closeLog: function closeLog() {
      this.$emit('update:showLog', false);
    },
    cannel: function cannel() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5__api_ajax__["a" /* revive */].returnIntegral().then(function (res) {
        _this.closeLog();
        _this.$router.push({
          name: 'wrong',
          query: {
            rightNum: _this.questionIndex,
            wrongId: _this.questionList[_this.questionIndex].id,
            first: true
          }
        });
      });
    },
    openApp: function openApp() {
      sa.track('activity', {
        action: 'vzb_dati2018',
        type: 'open_app'
      }, function () {
        location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.yxvzb.app';
      });
    },
    setRevive: function setRevive(a, b, c) {
      this.SETREVICE(false);
      this.closeLog();
      this.$emit('revive-card', true);
      this.$vux.toast.show({
        text: '复活成功，请继续答题',
        type: 'text',
        width: '7rem'
      });
      sa.track('activity', {
        action: 'vzb_dati2018',
        type: 'revive'
      }, function () {});
    },
    confirm: function confirm() {
      var _this2 = this;

      if (this.reviveNum < 1) {
        this.wrongFlag = false;
        this.appFlag = true;
      } else {

        if (!this.canClick) {
          return false;
        }
        this.canClick = false;
        __WEBPACK_IMPORTED_MODULE_5__api_ajax__["a" /* revive */].useReviveCard().then(function (res) {
          if (res.data.status == 1) {
            _this2.reviveNum -= 1;
            _this2.setRevive();
          }
        });
      }
    }
  }),
  computed: {},
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default.a,
    XDialog: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue___default.a
  },
  created: function created() {}
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "",
  props: {
    money: {
      type: Number,
      default: 0
    }
  },
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_2_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  data: function data() {
    return {
      show9: false,
      guideList: ["每位用户每天可进行一次答题拼图，限时180秒，四题全对即得红包，0.1~1元不等", "超时或答错则本轮答题结束", "每位用户每天可使用1张复活卡复活1次，复活卡需到医生汇APP积分商城兑换。", "答对四题有机会获赠系统发放的友情红包，可转赠好友，每人每天最多领取3个好友红包", "红包每满1元即可提现，提现前需先完善个人信息，提现以红包形式在医学V视界公众号发放", "本活动最终解释权归北京医洋科技有限公司所有"]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["showCoverAction"]), {
    jump: function jump() {
      sessionStorage.goBackUrl = location.href;
      location.href = "/html/perfect.html#/perfect";
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    popup: function popup(state) {
      return state.popup;
    }
  })),
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default.a,
    XDialog: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue___default.a
  },
  mounted: function mounted() {}
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_ajax_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Mixin_marquee_js__ = __webpack_require__(64);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "correct",
  mixins: [__WEBPACK_IMPORTED_MODULE_4__Mixin_marquee_js__["a" /* marquee */]],
  data: function data() {
    return {
      bestToday: [],
      scoreAmount: 0,
      myAnswerAmount: {}
    };
  },

  methods: {
    toast: function toast() {
      sa.track("activity", {
        action: "vzb_dati2018",
        type: "share"
      }, function () {});

      this.$sa.re_activity({
        name: "答题拼图",
        event_type: "点击分享"
      });

      this.$vux.toast.show({
        text: "点击右上角，分享给微信好友吧",
        type: "text",
        width: "7rem"
      });
    },
    toMyredpacket: function toMyredpacket() {

      this.$router.push({
        name: "myredpacket"
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    wxUserInfo: function wxUserInfo(state) {
      return state.wxUserInfo;
    }
  })),
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default.a
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    console.log(from);
    next();
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      if (!_this.$route.query.first) {
        _this.$vux.toast.show({
          text: "每天仅有一次答题机会,明天再来参加吧",
          type: "text",
          width: "7rem"
        });
      }
    }, 1000);
    __WEBPACK_IMPORTED_MODULE_2__api_ajax_js__["h" /* redAnswer */].bestToday().then(function (res) {
      _this.bestToday = res.data.data;
    });
    __WEBPACK_IMPORTED_MODULE_2__api_ajax_js__["g" /* myPacket */].myAnswerAmount().then(function (res) {
      _this.myAnswerAmount = res.data;

      if (!_this.myAnswerAmount.todayAmount) return false;
      var shareUrl = _this.$config.javaPath + "/html/answerGold/index210505.html#/share/" + _this.myAnswerAmount.redPackId + "?shareFlag=true";
      _this.$wxShareInfo("你领或不领，红包就在那里，不离不弃~", "但手速慢，被别人抢，可不能怪我没提醒", "http://cdn.yxvzb.com/html/AnswerGold/share2.png", location.href.split("#")[0], shareUrl, "");
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == "play") {
      next({
        name: "home"
      });
    } else {
      next(true);
    }
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'finshed',
  data: function data() {
    return {
      list: [{
        img_left: 'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%9B%B4%E6%92%AD@2x.png',
        p1: '直播',
        p2: '每天4场，准时开讲',
        type: 'live'
      }, {
        img_left: 'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E8%AF%BE%E7%A8%8B@2x.png',
        p1: '课程',
        p2: '覆盖13大学科，精彩应有尽有',
        type: 'course'
      }, {
        img_left: 'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%A4%B4%E6%9D%A1@2x.png',
        p1: '头条',
        p2: '新鲜资讯、病例，一网打尽',
        type: 'headline'
      }]
    };
  },

  methods: {
    jump: function jump(item) {
      if (item.type == 'live') {
        location.href = '/html/newWechat.html#/liveTrailer';
      } else if (item.type == 'course') {
        location.href = '/html/newWechat.html#/courseList';
      } else {
        location.href = '/html/newWechat.html#/headlineList';
      }
    }
  },
  computed: {},
  components: {},
  mounted: function mounted() {},
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'play') {
      next({ name: 'home' });
    } else {
      next();
    }
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_guideCover_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_guideCover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_guideCover_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "home",
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_2_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["showCoverAction"]), {
    jump: function jump(toName) {
      if (toName == "play") {
        this.$sa.re_activity({
          name: "答题拼图",
          event_type: "点击开始答题"
        });
      } else {
        this.$sa.re_activity({
          name: "答题拼图",
          event_type: "点击我的红包"
        });
      }
      if (!this.wxUserInfo.phone) {
        this.$api.setStorage("strLogin", {
          url: location.href,
          from: "answer"
        });
        var registerUrl = "/html/newWechat.html#/register";
        if (/sj-wx|doc\.jimijiayuan/.test(location.href)) {
          registerUrl = "/html/clinical/index.html#/register";
        }
        this.$sa.setSaSession_href(this.$route, registerUrl);
      } else {
        if (toName == "hb") {
          this.$router.push({
            name: "myredpacket"
          });
        } else {
          this.$router.push({
            name: "play"
          });
        }
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    wxUserInfo: function wxUserInfo(state) {
      return state.wxUserInfo;
    }
  })),
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default.a,
    XDialog: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_dialog_index_vue___default.a,
    GuideCover: __WEBPACK_IMPORTED_MODULE_5__components_guideCover_vue___default.a
  },
  mounted: function mounted() {
    this.$refs.home.style.height = document.body.clientHeight + "px";
    sa.track("activity", {
      action: "vzb_dati2018",
      type: "entry_home",
      from: this.$route.query.channelFrom ? this.$route.query.channelFrom : "yxvzb"
    }, function () {});
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guideCover_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guideCover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_guideCover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_ajax_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Mixin_marquee_js__ = __webpack_require__(64);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'correct',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__Mixin_marquee_js__["a" /* marquee */]],
  data: function data() {
    return {
      btList: ['获奖记录', '提现记录'],
      btIndex: -1,
      recordList: [],
      myAnswerAmount: {},
      translate3dY: 0,
      canAmount: 0,
      recordList2: 0,
      ttt: 123
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    toast: function toast() {
      this.$vux.toast.show({
        text: '点击右上角，分享给微信好友吧',
        type: 'text',
        width: '7rem'
      });
    },
    toWs: function toWs() {
      sessionStorage.goBackUrl = location.href;
      this.$sa.setSaSession_href(this.$route, '/html/perfect.html#/perfect');
    },
    tabClick: function tabClick(item, index) {

      this.btIndex = index;
    },
    ATM: function ATM() {
      var _this = this;

      this.$sa.re_activity({
        name: '答题拼图',
        event_type: '点击提现'
      });
      if (this.wxUserInfo.userDataStatus < 2) {
        this.showCoverAction({
          show: true,
          type: 4
        });
      } else {
        if (this.canAmount >= 1) {
          this.change(true);
          __WEBPACK_IMPORTED_MODULE_4__api_ajax_js__["g" /* myPacket */].tixian({
            amount: this.canAmount
          }).then(function (res) {
            _this.change(false);
            if (res.data.status != 0) {
              _this.canAmount = 0;
              _this.showCoverAction({
                show: true,
                type: 3
              });
            } else {
              _this.$vux.toast.show({
                text: res.data.message,
                type: 'text',
                width: '7rem'
              });
            }
          });
        } else {
          this.$vux.toast.show({
            text: '满一元方可提现',
            type: 'text',
            width: '7rem'
          });
        }
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['showCoverAction', 'change'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    wxUserInfo: function wxUserInfo(state) {
      return state.wxUserInfo;
    }
  })),
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default.a,
    GuideCover: __WEBPACK_IMPORTED_MODULE_3__components_guideCover_vue___default.a
  },
  watch: {
    btIndex: function btIndex(n, o) {
      var _this2 = this;

      this.recordList = [];
      this.destroy();
      this.currenTranslateY = 0;
      if (n > 0) {
        __WEBPACK_IMPORTED_MODULE_4__api_ajax_js__["g" /* myPacket */].myDepositRecord().then(function (res) {
          _this2.recordList = res.data.data;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_4__api_ajax_js__["g" /* myPacket */].myRedRecord().then(function (res) {
          _this2.recordList = res.data.data;
        });
      }
    }
  },
  filters: {},
  created: function created() {
    var _this3 = this;

    this.btIndex = 0;
    if (!sessionStorage.answerShowCover) {
      this.showCoverAction({
        show: true,
        type: 2
      });
    }
    sessionStorage.answerShowCover = true;
    __WEBPACK_IMPORTED_MODULE_4__api_ajax_js__["g" /* myPacket */].myAnswerAmount().then(function (res) {
      _this3.myAnswerAmount = res.data;
      _this3.canAmount = Math.floor(_this3.myAnswerAmount.scoreAmount - _this3.myAnswerAmount.cashAmount);
    });
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_ajax_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resurrection_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resurrection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resurrection_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'play',
  data: function data() {
    return {
      coverImgs: ['http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%AD%94%E9%A2%98%E9%A1%B5-%E6%8B%BC%E5%9B%BE%E6%9C%AA%E5%BE%97%EF%BC%88%E5%B7%A6%E4%B8%8A%EF%BC%89@2x.png', 'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%AD%94%E9%A2%98%E9%A1%B5-%E6%8B%BC%E5%9B%BE%E6%9C%AA%E5%BE%97%EF%BC%88%E5%8F%B3%E4%B8%8A%EF%BC%89@2x.png', 'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%AD%94%E9%A2%98%E9%A1%B5-%E6%8B%BC%E5%9B%BE%E6%9C%AA%E5%BE%97%EF%BC%88%E5%B7%A6%E4%B8%8B%EF%BC%89@2x.png', 'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%AD%94%E9%A2%98%E9%A1%B5-%E6%8B%BC%E5%9B%BE%E6%9C%AA%E5%BE%97%EF%BC%88%E5%8F%B3%E4%B8%8B%EF%BC%89@2x.png'],
      list: [],
      activeIndex: -1,
      canActive: true,
      time: '---',
      intervalId: null,
      questionIndex: 0,
      showLog: false,
      reviveNum: 0,
      integral: 0 };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['change']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['SETREVICE']), {
    jumpWrongPage: function jumpWrongPage(questionIndex, questionId) {
      this.questionIndex = questionIndex;
      if (this.hasUserRevice) {
        this.showLog = true;
      } else {
        this.$router.push({
          name: 'wrong',
          query: {
            rightNum: questionIndex,
            wrongId: questionId,
            first: true
          }
        });
      }
    },
    sendQuestion: function sendQuestion(answerResult) {
      var _this = this;

      var answerList = ['A', 'B', 'C', 'D', 'E'];
      var activeQuestionId = this.list[this.questionIndex].id;
      __WEBPACK_IMPORTED_MODULE_1__api_ajax_js__["b" /* answerAjax */].answerSingleQuestion({
        questionId: activeQuestionId,
        answer: answerResult ? answerResult : answerList[this.activeIndex]
      }).then(function (res) {
        if (res.data.isRight == 1) {
          _this.canActive = true;
          _this.questionIndex += 1;
          _this.activeIndex = -1;
        } else if (res.data.isRight != 1) {
          _this.jumpWrongPage(_this.questionIndex, activeQuestionId);
        }
      }).catch(function (e) {
        _this.$vux.toast.show({
          text: '请您检查网络',
          type: 'text',
          width: '7rem'
        });
      });
    },
    activeClick: function activeClick(item, index, parentItem) {
      if (this.canActive) {
        this.canActive = false;
        this.activeIndex = index;
        this.sendQuestion(null);
      }
    },
    useReviveCard: function useReviveCard(arg) {
      if (arg) {
        this.canActive = true;
        this.questionIndex += 1;
        this.activeIndex = -1;
      }
    },
    getTimeAndOption: function getTimeAndOption() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_ajax_js__["b" /* answerAjax */].obtainUserRandomQuestion().then(function (list) {
        __WEBPACK_IMPORTED_MODULE_1__api_ajax_js__["b" /* answerAjax */].obtainTiming().then(function (time) {
          __WEBPACK_IMPORTED_MODULE_1__api_ajax_js__["a" /* revive */].myReviveCard().then(function (res) {
            _this2.reviveNum = res.data.count;
            _this2.integral = res.data.integral;
          });
          _this2.time = time.data.timing;

          _this2.list = list.data.data;
          _this2.list.filter(function (item, index) {
            if (item.isRight) {
              if (item.isRight == '0') {
                _this2.jumpWrongPage(index, item.id);
                if (index > 0) {
                  _this2.coverImgs[index - 1] = 'http://cdn.yxvzb.com/html/AnswerGold/' + index + '.png';
                }
                return false;
              } else if ((item.isRight == '1' || item.isRight == '3') && index < 3 && !_this2.list[index + 1].isRight) {
                _this2.questionIndex = index + 1;
              } else if (index >= 3) {
                _this2.$router.push({
                  name: 'correct',
                  query: {
                    first: true
                  }
                });
              }
              _this2.coverImgs[index] = 'http://cdn.yxvzb.com/html/AnswerGold/' + (index + 1) + '.png';
            }
          });
          _this2.intervalId = setInterval(function () {
            if (_this2.time <= 0) {
              clearInterval(_this2.intervalId);
              __WEBPACK_IMPORTED_MODULE_1__api_ajax_js__["b" /* answerAjax */].endTimeSubmit({ questionId: _this2.list[_this2.questionIndex].id }).then(function (res) {
                _this2.$router.push({
                  name: 'wrong',
                  query: {
                    rightNum: _this2.questionIndex,
                    wrongId: _this2.list[_this2.questionIndex].id,
                    first: true
                  }
                });
              });
            } else {
              if (typeof _this2.time == 'number') {
                _this2.time -= 1;
              }
            }
          }, 1000);

          _this2.change(false);
        });
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    hasUserRevice: function hasUserRevice(state) {
      return state.hasUserRevice;
    }
  })),
  components: {
    Resurrection: __WEBPACK_IMPORTED_MODULE_3__components_Resurrection_vue___default.a
  },
  watch: {
    questionIndex: function questionIndex(n, o) {
      if (n > 0) {
        this.coverImgs[n - 1] = 'http://cdn.yxvzb.com/html/AnswerGold/' + n + '.png';
      }
      if (n > 3) {
        this.$router.push({
          name: 'correct',
          query: {
            first: true
          }

        });
      }
    }
  },
  created: function created() {
    this.change(true);
    this.getTimeAndOption();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.intervalId) {

      clearInterval(this.intervalId);
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guideCover_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guideCover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_guideCover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_ajax_js__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "share",
  data: function data() {
    return {
      btList: ["获奖记录", "提现记录"],
      btIndex: 0,
      recordList: [],
      getMoney: 0,
      hasMore: true
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    toHome: function toHome() {
      sa.track("activity", {
        action: "vzb_dati2018",
        type: "share_to_start"
      }, function () {});

      this.$sa.re_activity({
        name: "答题拼图",
        event_type: "点击去首页"
      });

      this.$router.push({
        name: "home"
      });
    },
    toast: function toast() {
      this.$vux.toast.show({
        text: "点击右上角，分享给微信好友吧",
        type: "text",
        width: "7rem"
      });
    },
    tabClick: function tabClick(item, index) {
      this.btIndex = index;
    },
    ATM: function ATM(item, index) {
      var _this = this;

      this.change(true);
      sa.track("activity", {
        action: "vzb_dati2018",
        type: "red_pocket"
      }, function () {});

      this.$sa.re_activity({
        name: "答题拼图",
        event_type: "点击赶紧拆"
      });

      __WEBPACK_IMPORTED_MODULE_4__api_ajax_js__["f" /* sharePageData */].unPackRedPack({
        redPackId: this.$route.params.redPackId,
        wxOpenId: this.wxUserInfo.wxOpenId,
        nickName: this.wxUserInfo.nickName,
        headPhoto: this.wxUserInfo.headPhoto
      }).then(function (res) {
        _this.getData(false);
        var message = res.data.message;
        var code = res.data.code;
        if (code == 1) {

          _this.getMoney = res.data.redPack;
          _this.showCoverAction({
            show: true,
            type: 7
          });
        } else if (code == 102) {

          _this.showCoverAction({
            show: true,
            type: 6
          });
        } else if (code == 104) {

          _this.showCoverAction({
            show: true,
            type: 5
          });
        } else {
          _this.$vux.toast.show({
            text: message,
            type: "text",
            width: "7rem"
          });
        }
        _this.change(false);
      });
    },
    getData: function getData(isFirst) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__api_ajax_js__["f" /* sharePageData */].sharePageData({
        redPackId: this.$route.params.redPackId,
        shareUserId: ""
      }).then(function (res) {
        if (res.data.status == "1") {
          _this2.recordList = res.data.data;
          if (_this2.recordList[1].nickName && _this2.recordList[2].nickName) {
            _this2.hasMore = false;
          }
          if (isFirst) {
            var shareUrl = _this2.$config.javaPath + "/html/answerGold/index210505.html#/share/" + _this2.$route.params.redPackId + "?shareFlag=true";
            _this2.$wxShareInfo("你领或不领，红包就在那里，不离不弃~", "但手速慢，被别人抢，可不能怪我没提醒", "http://cdn.yxvzb.com/html/AnswerGold/share2.png", location.href.split("#")[0], shareUrl, "");
          }
        } else {
          _this2.$vux.toast.show({
            text: res.data.message,
            type: "text",
            width: "7rem"
          });

          _this2.$router.push({
            name: "home"
          });
        }
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["showCoverAction", "change"])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    wxUserInfo: function wxUserInfo(state) {
      return state.wxUserInfo;
    }
  })),
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default.a,
    GuideCover: __WEBPACK_IMPORTED_MODULE_3__components_guideCover_vue___default.a
  },
  created: function created() {
    this.getData("first");
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_ajax_js__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'wrong',
    data: function data() {
        return {
            rightNum: 0,
            courseObj: {},
            integral: -1
        };
    },

    methods: {
        jump: function jump() {
            this.$sa.re_activity({
                name: '答题拼图',
                event_type: '点击错题正解'
            });
            this.courseObj.id && this.$sa.setSaSession_href(this.$route, '//wx.yxvzb.com/html/newWechat.html#/courseDetail/' + this.courseObj.id);
        }
    },
    watch: {},
    computed: {},
    components: {},
    created: function created() {
        var _this = this;

        setTimeout(function () {
            if (!_this.$route.query.first) {
                _this.$vux.toast.show({
                    text: '每天仅有一次答题机会,明天再来参加吧',
                    type: 'text',
                    width: '7rem'
                });
            }
        }, 1000);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_ajax_js__["i" /* wrongAnswerCourse */])({
            questionId: this.$route.query.wrongId
        }).then(function (res) {
            _this.courseObj = res.data.data[0];
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_ajax_js__["j" /* todayAnswerPrize */])().then(function (res) {
            _this.integral = res.data.integral;
            console.log(_this.integral);
        });
        this.rightNum = this.$route.query.rightNum || 0;
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {

        if (to.name == 'play') {
            next({
                name: 'home'
            });
        } else {
            next(true);
        }
    }
});

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "weui-btn",
    class: _vm.classes,
    style: (_vm.buttonStyle),
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.actionType
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.showLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e(), _vm._v(" "), _vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.text))]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "play"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "time_div"
  }, [_c('p', {
    staticClass: "time_p1"
  }, [_vm._v("答对四题拼红包")]), _vm._v(" "), _c('p', {
    staticClass: "time_p2"
  }, [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), _c('div', {
    staticClass: "pt"
  }, _vm._l((_vm.coverImgs), function(item) {
    return _c('img', {
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), 0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "bounceInRight"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return (index == _vm.questionIndex) ? _c('div', {
      key: item.id,
      staticClass: "content"
    }, [_c('div', {
      staticClass: "title_div"
    }, [_c('img', {
      attrs: {
        "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%AD%94%E9%A2%98%E9%A1%B5-%E9%97%AE%E9%A2%98@2x.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v("\r\n          " + _vm._s(item.title) + "\r\n\r\n        ")])]), _vm._v(" "), _c('ul', _vm._l((item.option), function(item2, index2) {
      return (item2.name) ? _c('li', {
        key: item2.name,
        class: [index2 == _vm.activeIndex ? 'active' : 'notActive'],
        on: {
          "click": function($event) {
            return _vm.activeClick(item2, index2, item)
          }
        }
      }, [_vm._v("\r\n          " + _vm._s(item2.name) + "\r\n        ")]) : _vm._e()
    }), 0)]) : _vm._e()
  }), 0), _vm._v(" "), _c('resurrection', {
    attrs: {
      "show-log": _vm.showLog,
      "question-index": _vm.questionIndex,
      "question-list": _vm.list,
      "revive-num": _vm.reviveNum,
      "integral": _vm.integral
    },
    on: {
      "update:showLog": function($event) {
        _vm.showLog = $event
      },
      "update:show-log": function($event) {
        _vm.showLog = $event
      },
      "revive-card": _vm.useReviveCard
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "introduce",
    on: {
      "click": function($event) {
        return _vm.showCoverAction({
          show: true,
          type: 1
        })
      }
    }
  }, [_vm._v("\n    活动介绍\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mid"
  }, [_c('div', {
    staticClass: "mid_div"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "mid_right"
  }, _vm._l((_vm.recordList), function(item, index) {
    return _c('li', {
      key: item.chaiId
    }, [(index == 0) ? _c('div', [_c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0.133rem"
      }
    }, [_vm._v("好友")]), _c('img', {
      attrs: {
        "src": item.headPhoto,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName))])]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "s1"
    }, [_vm._v("答题得红包")]), _c('span', {
      staticClass: "r"
    }, [_vm._v("￥" + _vm._s(item.redPack) + "元")])])]) : (item.nickName && index > 0) ? _c('div', [_c('div', [_c('img', {
      attrs: {
        "src": item.headPhoto,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName))])]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "s1"
    }, [_vm._v("喜得红包")]), _c('span', {
      staticClass: "r"
    }, [_vm._v("￥" + _vm._s(item.redPack) + "元")])])]) : _c('x-button', {
      staticClass: "send_bt",
      nativeOn: {
        "click": function($event) {
          return _vm.ATM(item, index)
        }
      }
    }, [_vm._v("赶紧拆")])], 1)
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "has_not_p"
  }, [_vm._v("\n    " + _vm._s(!_vm.hasMore ? "红包已开完，快去寻找下一个吧" : "") + "\n  ")]), _vm._v(" "), _c('x-button', {
    staticClass: "go_bt",
    nativeOn: {
      "click": function($event) {
        return _vm.toHome.apply(null, arguments)
      }
    }
  }, [_vm._v("答题得红包")]), _vm._v(" "), _c('guide-cover', {
    attrs: {
      "money": _vm.getMoney
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', [_c('p', [_vm._v("连对四题，即可凑齐拼图拆现金红包")]), _vm._v(" "), _c('p', [_vm._v("更有机会获得友情红包，可转赠好友")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mid_left"
  }, [_c('li', [_c('img', {
    staticClass: "f",
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%88%86%E4%BA%AB%E9%A1%B5-%E5%A5%BD%E5%8F%8B%E7%BA%A2%E5%8C%85@2x.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%88%86%E4%BA%AB%E9%A1%B5-%E7%BA%A2%E5%8C%85@2x.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%88%86%E4%BA%AB%E9%A1%B5-%E7%BA%A2%E5%8C%85@2x.png",
      "alt": ""
    }
  })])])
}]}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading",
    class: !_vm.text ? 'vux-loading-no-text' : ''
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        return _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        return _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", function() {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.content)
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrong"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("答对四题拼红包")]), _vm._v(" "), _c('img', {
    staticClass: "wrong_top_img",
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/%E7%AD%94%E9%94%99%E4%BA%86-%E5%A4%B4%E9%83%A8@2x_03.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p1 p2"
  }, [_vm._v("好遗憾，答错了")]), _vm._v(" "), (_vm.integral < 1) ? _c('p', {
    staticClass: "p1 p3"
  }, [_vm._v("整理心情，明天继续加油吧~")]) : (_vm.integral > 0) ? _c('p', {
    staticClass: "p1 p3"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/%E7%AD%94%E9%94%99%E4%BA%86-%E7%A7%AF%E5%88%86@2x.png",
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.integral) + "积分鼓励奖已经放入你的账户")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    on: {
      "click": _vm.jump
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "b_mid"
  }, [_c('div', {
    staticClass: "b_m_a"
  }, [_c('div', {
    staticClass: "b_m_a_b"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/err-t.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {}, [_c('p', {
    staticClass: "b_b_p1"
  }, [_vm._v(_vm._s(_vm.courseObj.title))]), _vm._v(" "), _c('p', {
    staticClass: "b_b_p2"
  }, [_vm._v("正解: " + _vm._s(_vm.courseObj.correctAnswer))])])])]), _vm._v(" "), _c('div', {
    staticClass: "video_box"
  }, [_c('img', {
    staticClass: "video_pic",
    attrs: {
      "src": _vm.courseObj.pic1,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video_right"
  }, [_c('p', {
    staticClass: "video_title"
  }, [_vm._v(_vm._s(_vm.courseObj.course_name))]), _vm._v(" "), _c('p', {
    staticClass: "video_bottom"
  }, [_c('span', [_vm._v(_vm._s(_vm.courseObj.FULL_NAME))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.courseObj.DUTIES))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b_top"
  }, [_c('p', {
    staticClass: "p4"
  }, [_vm._v("快去看看这道题的正解")])])
}]}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view', {
    staticClass: "child-view"
  })], 1), _vm._v(" "), _c('loading', {
    model: {
      value: (_vm.change),
      callback: function($$v) {
        _vm.change = $$v
      },
      expression: "change"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    class: {
      'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask",
    style: (_vm.maskStyle),
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.hide.apply(null, arguments)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.dialogClass,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], 2)])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style)
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "correct"
  }, [(_vm.myAnswerAmount.todayAmount) ? _c('div', [_c('div', {
    staticClass: "hb"
  }, [_c('p', [_vm._v("¥" + _vm._s(_vm.myAnswerAmount.todayAmount))])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("恭喜，红包到手")]), _vm._v(" "), _c('div', {
    staticClass: "look_div"
  }, [_c('span', {
    staticClass: "s1"
  }, [_vm._v("您已累计获得")]), _vm._v(" "), _c('span', {
    staticClass: "s2"
  }, [_vm._v(_vm._s(_vm.myAnswerAmount.scoreAmount) + " 元")]), _vm._v(" "), _c('x-button', {
    staticClass: "look_bt",
    nativeOn: {
      "click": function($event) {
        return _vm.toMyredpacket.apply(null, arguments)
      }
    }
  }, [_vm._v("查看")])], 1), _vm._v(" "), _c('p', {
    staticClass: "p1",
    staticStyle: {
      "font-size": "0.3733rem",
      "margin-top": "0.8rem"
    }
  }, [_vm._v("\n      可喜可贺，额外获赠两个友情红包\n    ")]), _vm._v(" "), _c('x-button', {
    staticClass: "invitation_bt",
    nativeOn: {
      "click": function($event) {
        return _vm.toast.apply(null, arguments)
      }
    }
  }, [_vm._v("转赠好友")])], 1) : _c('div', {
    staticClass: "no_money"
  }, [_c('img', {
    attrs: {
      "src": "//cdn.yxvzb.com/WEB/images/answergold120.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("今日红包已领完")]), _vm._v(" "), _c('p', [_vm._v("请您明日再来")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "getHbs",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.bestToday.length) ? _c('ul', {
    ref: "box",
    staticClass: "ul_box",
    style: ({
      transform: ("translate3d(0," + _vm.currenTranslateY + "px,0)"),
      transition: ("transform " + (_vm.noAnimate ? 0 : _vm.duration) + "ms"),
    })
  }, _vm._l((_vm.bestToday), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "h_s1"
    }, [_vm._v(_vm._s(_vm._f("transHours")(item.createTime)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "2.5rem:text-align:left"
      }
    }, [_c('img', {
      attrs: {
        "src": item.headPhoto,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "h_s2"
    }, [_vm._v(_vm._s(item.nickName))])]), _vm._v(" "), _c('span', {
      staticClass: "h_s3"
    }, [_vm._v("￥" + _vm._s(item.redPack) + "元")])])
  }), 0) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right_img_top"
  }, [_c('p', [_vm._v("今日手气最佳")])])
}]}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    on: {
      "click": function($event) {
        return _vm.showCoverAction(false)
      }
    }
  }, [_c('x-dialog', {
    staticClass: "dialog-demo",
    model: {
      value: (_vm.popup.show),
      callback: function($$v) {
        _vm.$set(_vm.popup, "show", $$v)
      },
      expression: "popup.show"
    }
  }, [(_vm.popup.type == 1) ? _c('div', {
    staticClass: "guideCover currencyBox"
  }, [_c('p', {
    staticStyle: {
      "font-size": "0.4533rem"
    }
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('ul', _vm._l((_vm.guideList), function(item) {
    return _c('li', [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "2.93rem",
      "display": "block",
      "margin": "auto"
    },
    attrs: {
      "src": "//cdn.yxvzb.com/img/Group118.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.2666rem"
    }
  }, [_vm._v("公众号：医学V视界")])]) : _vm._e(), _vm._v(" "), (_vm.popup.type == 2) ? _c('div', {
    staticClass: "currencyBox",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-bottom": "0.4533rem"
    }
  }, [_vm._v("\n          重要提示\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.3733rem",
      "text-align": "left"
    }
  }, [_vm._v("\n          提现将由“医学V视界”公众号以微信红包的形式发送。提现时请确保关注此公众号中。\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.3733rem",
      "text-align": "left"
    }
  }, [_vm._v("\n          由于未关注公众号而导致提现失败，相关责任及损失将由您个人承担。\n        ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "2.93rem",
      "display": "block",
      "margin": "auto",
      "margin-top": "0.48rem"
    },
    attrs: {
      "src": "//cdn.yxvzb.com/img/Group118.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.2666rem",
      "margin-top": "0.133rem"
    }
  }, [_vm._v("\n          公众号：医学V视界\n        ")]), _vm._v(" "), _c('x-button', {
    staticClass: "bt1",
    nativeOn: {
      "click": function($event) {
        return _vm.showCoverAction(false)
      }
    }
  }, [_vm._v("我知道了")])], 1) : _vm._e(), _vm._v(" "), (_vm.popup.type == 3) ? _c('div', {
    staticClass: "currencyBox"
  }, [_c('img', {
    staticStyle: {
      "width": "0.9866rem",
      "margin-top": "0.2133rem"
    },
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E6%8F%90%E7%8E%B0%E6%88%90%E5%8A%9F@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-top": "0.72rem"
    }
  }, [_vm._v("\n          提现成功，请查收红包\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#666",
      "margin-top": "0.32rem"
    }
  }, [_vm._v("\n          如未收到，请在公众号留言与客服联系\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.popup.type == 4) ? _c('div', {
    staticClass: "currencyBox"
  }, [_c('img', {
    staticStyle: {
      "width": "0.9866rem",
      "margin-top": "0.2133rem"
    },
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%AE%8C%E5%96%84%E4%BF%A1%E6%81%AF@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-top": "0.4rem"
    }
  }, [_vm._v("\n          提现用户需完善信息\n        ")]), _vm._v(" "), _c('x-button', {
    staticClass: "bt1",
    staticStyle: {
      "margin-top": "0.64rem"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.jump.apply(null, arguments)
      }
    }
  }, [_vm._v("前往完善")])], 1) : _vm._e(), _vm._v(" "), (_vm.popup.type == 5) ? _c('div', {
    staticClass: "currencyBox"
  }, [_c('img', {
    staticStyle: {
      "width": "0.9866rem",
      "margin-top": "0.2133rem"
    },
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%AE%8C%E5%96%84%E4%BF%A1%E6%81%AF@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-top": "0.72rem"
    }
  }, [_vm._v("\n          每天最多领取3个好友红包\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#666",
      "margin-top": "0.32rem"
    }
  }, [_vm._v("\n          把机会留给别人吧\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.popup.type == 6) ? _c('div', {
    staticClass: "currencyBox"
  }, [_c('img', {
    staticStyle: {
      "width": "1.24rem",
      "margin-top": "0.2133rem"
    },
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E6%9C%AA%E6%8A%A2%E5%88%B0%E7%BA%A2%E5%8C%85-%E5%BC%B9%E5%B1%82@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-top": "0.4rem"
    }
  }, [_vm._v("\n          差一点就抢到红包了\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#666",
      "margin-top": "0.32rem"
    }
  }, [_vm._v("\n          下次一定要眼疾手快哦\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.popup.type == 7) ? _c('div', {
    staticClass: "currencyBox"
  }, [_c('img', {
    staticStyle: {
      "width": "5.6rem",
      "margin-top": "0.2133rem"
    },
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%BE%97%E7%BA%A2%E5%8C%85-%E5%BC%B9%E5%B1%82@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-top": "0.8rem"
    }
  }, [_vm._v("\n          恭喜，获得红包"), _c('span', {
    staticStyle: {
      "color": "#e22b1b",
      "margin-left": "0.21rem"
    }
  }, [_vm._v("¥" + _vm._s(_vm.money) + "元")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#666",
      "margin-top": "0.32rem"
    }
  }, [_vm._v("\n          累计满1元后，记得关注“医学V视界”提现\n        ")])]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "finshed"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("猜你喜欢")]), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.jump(item)
        }
      }
    }, [_c('img', {
      staticClass: "img_left",
      attrs: {
        "src": item.img_left,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(item.p1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.p2))])]), _vm._v(" "), _c('img', {
      staticClass: "img_right",
      attrs: {
        "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/arrow-right.png",
        "alt": ""
      }
    })])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', [_c('p', [_vm._v("今天已答题")]), _vm._v(" "), _c('p', [_vm._v("明天不见不散")])])])
}]}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wrongFlag),
      expression: "wrongFlag"
    }],
    staticClass: "dialog-demo",
    model: {
      value: (_vm.showLog),
      callback: function($$v) {
        _vm.showLog = $$v
      },
      expression: "showLog"
    }
  }, [_c('div', {
    staticClass: "res-box"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("好遗憾，答错了")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("复活后才可继续答题哦~每日限一次")]), _vm._v(" "), _c('div', {
    staticClass: "mid-box"
  }, [_c('img', {
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%A4%8D%E6%B4%BB%E5%8D%A1@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("X")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.reviveNum > 99 ? '99+' : _vm.reviveNum))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-box"
  }, [_c('x-button', {
    staticClass: "cannel currency",
    nativeOn: {
      "click": function($event) {
        return _vm.cannel.apply(null, arguments)
      }
    }
  }, [_vm._v("算了")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-box"
  }, [_c('x-button', {
    staticClass: "confirm currency",
    nativeOn: {
      "click": function($event) {
        return _vm.confirm.apply(null, arguments)
      }
    }
  }, [_vm._v("复活 ")])], 1)], 1)])]), _vm._v(" "), _c('x-dialog', {
    staticClass: "app-box",
    model: {
      value: (_vm.appFlag),
      callback: function($$v) {
        _vm.appFlag = $$v
      },
      expression: "appFlag"
    }
  }, [_c('div', {
    staticClass: "res-box"
  }, [_c('span', {
    staticStyle: {
      "font-size": ".6rem"
    },
    on: {
      "click": _vm.cannel
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/img/luotai/u8.png"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n              您的复活卡用完了，请打开医生汇APP积分商城兑换复活卡。\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "1rem",
      "padding": "0 .5rem",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "canBtn",
    on: {
      "click": _vm.cannel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "openBtn",
    on: {
      "click": _vm.openApp
    }
  }, [_vm._v("打开APP")])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "correct"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "introduce",
    on: {
      "click": function($event) {
        return _vm.showCoverAction({
          show: true,
          type: 1
        })
      }
    }
  }, [_vm._v("活动介绍")]), _vm._v(" "), _c('div', {
    staticClass: "mid"
  }, [_c('div', [_c('p', {
    staticClass: "p1"
  }, [_c('span', [_vm._v("累计获得红包")]), _c('span', [_vm._v(_vm._s(_vm.myAnswerAmount.scoreAmount || 0) + "元")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', [_vm._v("可提现金额")]), _c('span', [_vm._v(_vm._s(_vm.canAmount || 0) + "元")])]), _vm._v(" "), (_vm.wxUserInfo.userDataStatus < 2) ? _c('p', {
    staticClass: "p3"
  }, [_c('span', [_vm._v("仅限医生提现，快去")]), _c('span', {
    on: {
      "click": _vm.toWs
    }
  }, [_vm._v("完善信息")])]) : _vm._e()]), _vm._v(" "), _c('x-button', {
    staticClass: "send_bt",
    nativeOn: {
      "click": function($event) {
        return _vm.ATM.apply(null, arguments)
      }
    }
  }, [_vm._v("立即提现")])], 1), _vm._v(" "), _c('img', {
    staticClass: "img1",
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/%E6%88%91%E7%9A%84%E7%BA%A2%E5%8C%85%E9%A1%B5-%E8%A3%85%E9%A5%B0%E5%85%83%E7%B4%A0@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bt_box"
  }, _vm._l((_vm.btList), function(item, index) {
    return _c('div', {
      class: ['tab_bt', _vm.btIndex == index ? 'active_bt' : 'not_bt'],
      on: {
        "click": function($event) {
          return _vm.tabClick(item, index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "getHbs",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.recordList.length) ? _c('ul', {
    ref: "box",
    staticClass: "ul_box",
    style: ({
      transform: ("translate3d(0," + _vm.currenTranslateY + "px,0)"),
      transition: ("transform " + (_vm.noAnimate ? 0 : _vm.duration) + "ms")
    })
  }, _vm._l((_vm.recordList), function(item, index) {
    return _c('li', {
      staticClass: "lis"
    }, [_c('span', {
      staticClass: "h_s1"
    }, [_vm._v(_vm._s(_vm._f("mmdd")(item.createTime)))]), _vm._v(" "), (_vm.btIndex == 0 && item.redPack) ? _c('span', {
      staticClass: "h_s2"
    }, [_vm._v(_vm._s(item.courceType == 1 ? '拼图得红包' : '好友分享'))]) : (_vm.btIndex == 0 && item.integral) ? _c('span', {
      staticClass: "h_s2"
    }, [_vm._v("鼓励奖")]) : _c('span', {
      staticClass: "h_s2",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("提现")]), _vm._v(" "), (_vm.btIndex == 0 && item.redPack) ? _c('span', {
      staticClass: "h_s3"
    }, [_vm._v("￥" + _vm._s(item.redPack) + "元")]) : (_vm.btIndex == 0 && item.integral) ? _c('span', {
      staticClass: "h_s3"
    }, [_vm._v(_vm._s(item.integral) + "积分")]) : (_vm.btIndex == 1) ? _c('span', {
      staticClass: "h_s3"
    }, [_vm._v("￥" + _vm._s(item.cashAmount) + "元")]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.recordList.length) ? _c('div', {
    staticClass: "no_more"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/%E6%88%91%E7%9A%84%E7%BA%A2%E5%8C%85%E9%A1%B5-%E7%BC%BA%E7%9C%81@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("什么都没有")])]) : _vm._e()]), _vm._v(" "), _c('guide-cover')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', [_c('p', [_vm._v("连对四题，即可凑齐拼图拆现金红包")]), _vm._v(" "), _c('p', [_vm._v("更有机会获得友情红包，可转赠好友")])])])
}]}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home",
    staticClass: "home"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/%E5%BC%80%E5%A7%8B%E9%A1%B5-%E5%BA%95@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bt_box"
  }, [_c('x-button', {
    staticClass: "start",
    nativeOn: {
      "click": function($event) {
        return _vm.jump('play')
      }
    }
  }, [_vm._v("开始答题")]), _vm._v(" "), _c('div', {
    staticClass: "bt_bottom_div"
  }, [_c('x-button', {
    staticClass: "guide currency_home",
    nativeOn: {
      "click": function($event) {
        return _vm.showCoverAction({
          show: true,
          type: 1
        })
      }
    }
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('x-button', {
    staticClass: "redpacket currency_home",
    nativeOn: {
      "click": function($event) {
        return _vm.jump('hb')
      }
    }
  }, [_vm._v("我的红包")])], 1), _vm._v(" "), _c('p', [_vm._v("如需帮助，请在“医学V视界”公众号留言")])], 1), _vm._v(" "), _c('guide-cover')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top_text"
  }, [_c('p', [_vm._v("连对四题，即可凑齐拼图拆现金红包")]), _vm._v(" "), _c('p', [_vm._v("更有机会获得友情红包，可转赠好友")])])
}]}

/***/ }),
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(235),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(234),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(239),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  "data-v-a9af0e5c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(240),
  /* scopeId */
  "data-v-6a352cdd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(242),
  /* scopeId */
  "data-v-8b880280",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)
__webpack_require__(215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  "data-v-c448fe58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(244),
  /* scopeId */
  "data-v-baa893a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(232),
  /* scopeId */
  "data-v-26caf0e9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(233),
  /* scopeId */
  "data-v-2afba040",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(236),
  /* scopeId */
  "data-v-3ac6e42e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[117]);


// WEBPACK FOOTER //
// static/js/app.54427c241c862d1ba108.js